'use strict';

export default class VZGroupSummary extends HTMLElement {
    constructor() {
        super();
        this.summaryList = this.querySelector('.js-configurator-summary-group-list');
    }

    connectedCallback() {
        this.addEventListener('portingChange', this.onPortingChange);
    }

    disconnectedCallback() {
        this.removeEventListener('portingChange', this.onPortingChange);
    }

    /**
     * @function onPortingChange
     * @private
     * @description updates the porting list item in the group summary
     * @param {Event} evt a portingChange event fired from VZPorting
     */
    onPortingChange(evt) {
        const { value: portingValue } = evt.detail;
        const portingListItem = this.querySelector('.js-porting-list-item');
        if (!portingListItem) return;
        const portingString = this.summaryList.dataset.portingString;
        portingListItem.textContent = `${portingValue} ${portingString}`;
    }
}

if (!window.customElements.get('vz-group-summary')) {
    window.customElements.define('vz-group-summary', VZGroupSummary);
}
